(function ($, window) {
    'use strict';

    var AUTOSIZE_FROM_WIDTH_SELECTOR = '.js-svg-autosize-from-width',
        AUTOSIZE_FROM_HEIGHT_SELECTOR = '.js-svg-autosize-from-height';

    var elementSelector = AUTOSIZE_FROM_WIDTH_SELECTOR + ', ' + AUTOSIZE_FROM_HEIGHT_SELECTOR;

    var resizeHandlerAttached = false;

    window.SVGAutoResize = function (e) {


        var doResize = function () {
            try {
                $(e).filter(elementSelector).each(window.SVGAutoResize.updateSize);
            } catch (ex) {
                console.log(ex);
            }
        };

        if (!resizeHandlerAttached)
            $(window).on('resize orientationchange', window.SVGAutoResize.updateAll);

        doResize();
    };

    window.SVGAutoResize.updateSize = function () {
        var $e = $(this);
        if (!this.viewBox)
            return;
        
        var viewBox = this.viewBox.baseVal;
        var width = viewBox.width;
        var height = viewBox.height;
        var aspect = width / height;

        if ($e.is(AUTOSIZE_FROM_HEIGHT_SELECTOR))
            $e.width($e[0].getBoundingClientRect().height * aspect);
        if ($e.is(AUTOSIZE_FROM_WIDTH_SELECTOR))
            $e.height($e[0].getBoundingClientRect().width * (1 / aspect));

    };

    window.SVGAutoResize.updateAll = function () {
        $(elementSelector).each(window.SVGAutoResize.updateSize);

    };

})(jQuery, window);
